import { DialogType } from '@tableau/widgets';
import * as React from 'react';

import { Messages } from '../../codegen/Localize';
import { CommonStyles } from '../../common/react/CommonStyles';
import { EditableDescription } from '../../common/react/components/EditableDescription';
import { FlowBaseInfo, FlowDetailInfo } from '../../ts/models/FlowInfo';
import { RunFlowTaskInfo } from '../../ts/models/RunFlowTaskInfo';
import { ModalInstance, ReactModalService } from '../../ts/services/ReactModalService';
import {
  editFlowRunSchedulesDialog,
  getFlowRunSchedulesDialog
} from '../components/FlowRunSchedulesDialog';

export function openCreateFlowRunTaskDialog(flowInfo: FlowBaseInfo, outputId?: string): ng.IPromise<any> {
  let modalInstance: ModalInstance;
  const dismiss = () => modalInstance.dismiss();
  const dialog = getFlowRunSchedulesDialog(flowInfo, dismiss, outputId);
  modalInstance = ReactModalService.open(dialog);
  return modalInstance.result.catch(reason => {});
}

export function editFlowRunTaskDialog(flowTask: RunFlowTaskInfo): ng.IPromise<any> {
  let modalInstance: ModalInstance;
  const dismiss = () => modalInstance.dismiss();
  const dialog = editFlowRunSchedulesDialog(flowTask, dismiss);
  modalInstance = ReactModalService.open(dialog);
  return modalInstance.result.catch(reason => {});
}

export function openEditFlowDescriptionDialog(flowInfo: FlowDetailInfo, handleSubmit: (text: string) => ng.IPromise<any>): ng.IPromise<any> {
  let modalInstance: ModalInstance;
  const dismiss = () => modalInstance.dismiss();
  const onSubmit = (text: string) => {
    handleSubmit(text);
    modalInstance.dismiss();
  };
  const dialog = {
    title: Messages.editDescription(),
    type: DialogType.NormalWithoutTitleBar,
    dialogContent:
      <EditableDescription
        originalText={flowInfo.description}
        cancel={dismiss}
        onSubmit={onSubmit}
        startInEditMode={true}
        customMaxCharacterLength={4000}
      />,
    showCloseButton: true,
    dialogWidth: 720,
    dialogStyle: { backgroundColor: CommonStyles.Colors.Grey250 }
  };
  modalInstance = ReactModalService.open(dialog);
  return modalInstance.result.catch(reason => {});
}
